module.exports = __webpack_public_path__ + "static/media/Skip_hand.718056c5.svg";